export function sellerAdvisoryVacantLandCP1225() {
return [   // Release 2026-01-14 13:49:41
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 65.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Seller Brokerage Firm Name 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 48.72,
   left: 169.08,
   width: 358.56,
   height: 10.20
}
,
{
   page: 0,
   name: "Seller Brokerage Firm Name 3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 744.36,
   left: 73.08,
   width: 300.24,
   height: 10.20
}
,
{
   page: 0,
   name: "Seller", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 167.055,
   left: 180.001,
   width: 356.837,
   height: 14.146
}
,
{
   page: 0,
   name: "Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 193.237,
   left: 180.001,
   width: 356.837,
   height: 14.146
}
,
{
   page: 0,
   name: "Seller Broker Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 220.728,
   left: 180.001,
   width: 356.837,
   height: 14.146
}
,
{
   page: 0,
   name: "Seller Brokerage Firm Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 246.91,
   left: 180.001,
   width: 356.837,
   height: 14.146
}
,
{
   page: 1,
   name: "Seller Brokerage Firm Name 4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 48.72,
   left: 169.08,
   width: 358.56,
   height: 10.20
}
,
{
   page: 1,
   name: "Seller Brokerage Firm Name 5", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 744.36,
   left: 73.08,
   width: 300.24,
   height: 10.20
}
,
{
   page: 2,
   name: "Seller Brokerage Firm Name 6", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 48.72,
   left: 169.08,
   width: 358.56,
   height: 10.20
}
,
{
   page: 2,
   name: "Seller Brokerage Firm Name 7", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 744.36,
   left: 73.08,
   width: 300.24,
   height: 10.20
}
,
{
   page: 3,
   name: "Seller Brokerage Firm Name 8", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 48.72,
   left: 169.08,
   width: 358.56,
   height: 10.20
}
,
{
   page: 3,
   name: "Seller Brokerage Firm Name 9", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 744.36,
   left: 73.08,
   width: 300.24,
   height: 10.20
}
,
{
   page: 4,
   name: "Seller Brokerage Firm Name 10", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 47.52,
   left: 169.08,
   width: 358.56,
   height: 11.40
}
,
{
   page: 4,
   name: "Signature Seller Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 362.56,
   left: 72.0,
   width: 214.92,
   height: 13.091
}
,
{
   page: 4,
   name: "Date Signature Seller Broker", 
   fontSize: 9,
   type: "date",
   top: 362.56,
   left: 296.88,
   width: 76.68,
   height: 13.091
}
,
{
   page: 4,
   name: "Seller Brokerage Firm Name 11", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 744.36,
   left: 73.08,
   width: 300.24,
   height: 10.20
}
] }
